import LoadingSpinner from "~/components/LoadingSpinners/LoadingSpinner";
import { useKpiFigures } from "~/modules/dashboard/hooks/useKpiFigures.ts";
import { formatPercentage } from "~/utils/numberUtils.ts";

// Shows nothing for a user with no personal figures or when the figures fail: the KPI box already shows
// the error. While the figures load, it shows the label with a spinner, because `personal` is not known yet.
export function MonthUtilisation() {
	const { data, isPending } = useKpiFigures();

	if (!isPending && !data?.personal) return null;

	return (
		<p className="text-sm text-gray-500">
			Ø Utilization Monat{" "}
			<span className="font-semibold text-gray-900">
				{data?.personal ? formatPercentage(data.personal.month.utilisationPercentage) : (
					// The box has the height of a `text-sm` line, so the heading row does not jump.
					<span className="inline-flex min-h-5 min-w-12 items-center justify-center align-middle">
						<LoadingSpinner size="sm" theme="neutral" />
					</span>
				)}
			</span>
		</p>
	);
}
